export var stories = [
    {
        id: 0,
        title: "The Road to Wrestlemania",
        stages: [
            {
                id: 0,
                title: "Begins with a Rumble victory"
            },
            {
                id: 1,
                title: "The contract signing"
            },
            {
                id: 2,
                title: "The tag match siding together that ends in betrayal"
            },
            {
                id: 3,
                title: "The sneak attack that goes wrong"
            },
            {
                id: 4,
                title: "The last minute heat grab, beat down or bloodied"
            },
            {
                id: 5,
                title: "The show before the show of shows"
            }
        ]
    },
    {
        id: 1,
        title: "Redemption",
        stages: [
            {
                id: 0,
                title: "The return from injury"
            },
            {
                id: 1,
                title: "The interference that costs the match"
            },
            {
                id: 2,
                title: "The match that ends in a draw"
            },
            {
                id: 3,
                title: "The match that ends in chaos and rage"
            },
            {
                id: 4,
                title: "The match that ends in a bloodied and beaten"
            },
            {
                id: 5,
                title: "The loser leaves town"
            }
        ]
    },
    {
        id: 3,
        title: "The Betrayal of a Lifetime",
        stages: [
            {
                id: 0,
                title: "The formation of a dominant tag team"
            },
            {
                id: 1,
                title: "The tension and arguments leading up to a big match"
            },
            {
                id: 2,
                title: "The surprise betrayal during the match, causing the team to lose"
            },
            {
                id: 3,
                title: "The aftermath of the betrayal, including interviews and backstage confrontations"
            },
            {
                id: 4,
                title: "The challenger who takes advantage of the team's weakened state"
            },
            {
                id: 5,
                title: "The ultimate showdown between the two former allies"
            }
        ]
    },
    {
        id: 4,
        title: "The Rise of a New Champion",
        stages: [
            {
                id: 0,
                title: "The new wrestler's humble beginnings and struggles"
            },
            {
                id: 1,
                title: "The surprising win over a more established wrestler"
            },
            {
                id: 2,
                title: "The challenges and obstacles the new wrestler faces on their path to the top"
            },
            {
                id: 3,
                title: "The turning point where the new wrestler gains momentum and support from the fans"
            },
            {
                id: 4,
                title: "The championship match where the new wrestler faces the current champion"
            },
            {
                id: 5,
                title: "The epic showdown that ends in a new champion being crowned, against all odds."
            }
        ]
    }
];
